import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const deleteDeliveryZone = id =>
  privateAxios({
    method: 'delete',
    baseURL: adminAPI,
    url: `/deliveryzone/${id}`,
  });
